import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe, UpperCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ICICProposalFormPageRoutingModule } from './icic-proposal-form-routing.module';

import { ICICProposalFormPage } from './icic-proposal-form.page';
import { SharedComponentsModule } from 'src/app/components/shared-components.module';
// import {AutocompleteLibModule} from 'angular-ng-autocomplete';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    ICICProposalFormPageRoutingModule,
    SharedComponentsModule,
    // AutocompleteLibModule
  ],
  declarations: [ICICProposalFormPage,],
  providers: [
    TitleCasePipe,
    UpperCasePipe
  ]
})
export class ICICProposalFormPageModule {}
